import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const CellStack = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  max-width: 100%;
`;

const singleLineEllipsis = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Figma 2745-38725 — Caption 3 (12/18 Medium), text/high-emphasis. */
export const PrimaryText = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  ${singleLineEllipsis}
`;

/** Figma 2745-38725 — Overline 3 (10/14 Medium), text/medium-emphasis. */
export const SecondaryText = styled.span`
  ${typographyMixin("overline", 3)}
  color: ${rawColors.text.mediumEmphasis};
  ${singleLineEllipsis}
`;
